const roadmapSections = document.querySelectorAll("section.roadmap-slider ");
roadmapSections.forEach((section) => {
  let idx = 0;
  // const overlays = section.querySelectorAll(".slider .group .overlay");
  const slider = tns({
    container: section.querySelector(".slider"),
    items: 1,
    autoplay: true,
    controls: true,
    nav: true,
    navContainer: section.querySelector(".slider-nav"),
    loop: true,
    autoplayButtonOutput: false,
    controlsContainer: section.querySelector(".slider-controls"),
    speed: 400,
    gutter: 16,
    fixedHeight: true,
  });
});
